<div class="sidebar-container" [class.collapsed]="!visible" [style.width]="visible ? '320px' : '80px'">

  <div class="sidebar-header">
    <div class="logo-area">
      <img
        [src]="visible ? 'assets/images/logo_completo_go_energy_160.png' : 'assets/images/logo_go_energy_64.png'"
        alt="Logo"
        [attr.width]="visible ? 160 : 64"
        [attr.height]="visible ? 45 : 61"
        class="logo"
        [class.collapsed]="!visible"
        [routerLink]="'/'"
      />

      @if (visible) {
        <div class="version-environment-container">
          <span class="app-version">v{{ appVersion }}</span>
          <span class="app-environment">{{ environmentName }}</span>
        </div>
      } @else {
        <div class="version-environment-container-collapsed">
          <span class="app-version-collapsed">v{{ appVersion }}</span>
          <span class="app-environment-collapsed">{{ environmentName }}</span>
        </div>
      }
    </div>
  </div>

  <nav class="menu custom-scrollbar">
    @for (group of filteredMenuCategories(); track group.title) {
      <div class="menu-group">
        @if (visible) {
          <div class="group-title">{{ group.title }}</div>
        }

        <ul>
          @for (item of group.items; track item.label) {
            <li class="menu-item">
              <a
                [routerLink]="item.route"
                (click)="onNavigate()"
                class="menu-link"
                [class.active]="isMenuItemActive(item.route)"
                [class.collapsed]="!visible"
                [pTooltip]="!visible ? item.label : undefined"
                tooltipPosition="right"
              >
                <ng-icon [name]="item.icon"></ng-icon>

                @if (visible) {
                  <span class="label">{{ item.label }}</span>
                }
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </nav>

</div>

@if (visible && isMobile()) {
  <div class="sidebar-overlay" (click)="closeSidebar()"></div>
}
